import styled from "styled-components";

export const EventScheduleDateFilterWrapper = styled.div`
  padding: 20px 0;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  box-shadow: 0px 6px 12px 0px #00000026;
`;

export const EventScheduleDateHeader = styled.div`
  position: relative;
  padding: 0 16px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  gap: 5px;

  > .date {
    display: flex;
    align-items: center;
  }
`;

export const EventDateFilterWrapper = styled.div`
  overflow-x: auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EventDateFilterItem = styled.div<{
  isSelected: boolean;
  isToday: boolean;
  isBurl: boolean;
}>`
  width: 45px;
  height: 70px;
  text-align: center;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 30px;
  border: ${(p) =>
    p.isSelected
      ? "1px solid #7F25FB"
      : p.isToday
      ? "1px solid  #B7B7B7"
      : "none"};
  ${(p) => (p.isSelected ? "background: #7F25FB;" : "")};

  > .week {
    font-weight: 500;
    font-size: 14px;
    color: ${(p) => (p.isSelected ? "#fff" : "#b7b7b7")};
  }

  > .day {
    font-weight: 700;
    font-size: 14px;
    color: ${(p) => (p.isSelected ? "#fff" : p.isBurl ? "#b7b7b7" : "#000")};
  }

  > .count-wrapper {
    display: flex;
    gap: 2px;
    height: 4px;

    > .count {
      background: ${(p) => (p.isBurl ? "#FF8080" : "#ff0000")};
      width: 4px;
      height: 4px;
      border-radius: 50%;
    }
  }
`;

export const EventScheduleFilterWrapper = styled.div`
  display: flex;
  font-weight: 700;
  font-size: 20px;
  justify-content: space-between;
  align-items: center;

  > .filter-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;
